
module.exports = function () { return function () {}; };



// WEBPACK FOOTER //
// support/noop.js